<template>
<div class="allchain" >
	<leftnav class="fl" mkcode="B" itemcode="B-CSDSJ" title="城市大数据"></leftnav>
	<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
		<govheader></govheader>
		<div class="index_left_centerpage">  
		<div class="whitebox right_topbox">
			<div class="right_boxtitle">
				<span class="fl right_title">城市数据库</span> 
			</div>
			<div class="urbanList">
				<div class="province">
					<h5 class="ptitle">直辖市</h5>
					<div class="citylist"> 
						<span class="curp urbancurp" @click="routerlinkid('/urbanBigData',item.areaId,'city')"  v-for="(item,index) in municipalityData" :data="item.areaId">{{item.areaName}}</span> 
					</div>
				</div>
				<div class="province" v-for="(list,i) in urbanData">
					<h5 class="ptitle" :data="list.areaId">{{list.areaName}}</h5>
					<div class="citylist"> 
					<el-tooltip  v-for="(item,index) in list.children" :key="index" placement="bottom" effect="light" >
						<div slot="content" style="width: 500px;">
							<span class="curp urbancurp" @click="routerlinkid('/urbanBigData',items.areaId,'country')" :data="items.areaId" v-for="items in item.children">{{items.areaName}}</span>
						</div>
							<span class="curp urbancurp" @click="routerlinkid('/urbanBigData',item.areaId,'city')" :data="item.areaId">{{item.areaName}}</span> 
						</el-tooltip>
						
					</div>
				</div>
				<!-- <div class="opport-screen-list1"> 
						<dl class="opport-screen bdbe">
							<dt class="fl">大分类</dt>
							<dd class="fl">
							<span :class="searchtype == list.value?'a-screen current':'a-screen'" @click="searchtype = list.value;getlist(list.value);searchtype1=0" v-for="(list,i) in biglist">{{list.name}}</span>  
							</dd>
						</dl> 
				</div> -->
			</div> 
		</div> 
	<div class="index_block  whitebox oh" style="padding:30px 0px;margin-top: 10px;"> 
			 
	</div>
	</div>
	</div>
</div>
</template> 
<script>
import { dataInJs } from '../../utils/city';
import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
	  name: 'allchain',
	  computed: {
		...mapState({
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
			data(){return{ 
				title:"城市大数据",
				userdata:{}, 
				urbanData:dataInJs(),municipality:'&北京市&天津市&上海市&重庆市&',municipalityData:[],
			}},
			created(){  
				this.$nextTick(() => {
						// 禁用右键
						document.oncontextmenu = new Function("event.returnValue=false");
						// 禁用选择
						document.onselectstart = new Function("event.returnValue=false");
				});
				this.userdata = this.getuseriformation();
		  
			 this.municipalityData=this.urbanData.filter(list=>{
					return this.municipality.indexOf('&'+list.areaName+'&')>-1;
				})
				this.urbanData=this.urbanData.filter(list=>{
					return this.municipality.indexOf('&'+list.areaName+'&')<0;
				})
				console.log('城市大数据',this.municipalityData)
			},
			mounted() { 
			},
			methods: {
     test(cod){
						console.log(cod)
					}
			
			},
	}
</script>

<style> 
  
</style>
